import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { get } from '#utilities/js/ea/ajax.js'
import href from '#utilities/js/ea/href.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const { dataset, ariaExpanded } = button
    const { target } = dataset
    const from = target.substring(9)

    const url = href('mail/req_mailboxes', {
      sharer: from,
      expand: ariaExpanded === 'true' ? 'false' : 'true'
    })

    try {
      await get(url, { target: button })
    } catch (e) {
      console.error(e)
    }
  }
})

export default button => {
  onClick.listen(button)
}
